{
  "pageTitle": "Қоидаҳо ва сиёсатҳо",
  "pageIntro": "Ҳуҷҷатҳои зер барои VBB PLAY лоиҳаанд. То тасдиқи соҳибкор оид ба номи ширкат, иҷозатнома ва ҳуқуқи татбиқшаванда барои нашри асосӣ омода нестанд.",
  "draftBadge": "ЛОИҲА — интизори тасдиқ",
  "backToList": "Бозгашт ба ҳамаи қоидаҳо",
  "updatedLabel": "Версия",
  "version": "0.2-draft",
  "footerNote": "Ин матни тасдиқшудаи ҳуқуқӣ нест. Ба сайти зинда танҳо пас аз иҷозати алоҳида гузошта мешавад.",
  "navTitle": "Қоидаҳо",
  "categories": {
    "terms": {
      "title": "Қоидаҳои истифода",
      "summary": "Кушодани ҳисоб, истифодаи платформа ва уҳдадориҳои асосӣ.",
      "sections": [
        {
          "heading": "1. Умумӣ",
          "body": "VBB PLAY платформаи бозиҳои онлайн ва хидматҳои алоқаманд аст. Бақайдгирӣ ё истифода қабули ин қоидаҳоро дорад. Номи расмии ширкат, кишвари бақайдгирӣ ва иҷозатнома пас аз тасдиқи соҳибкор илова мешавад."
        },
        {
          "heading": "2. Ҳисоб",
          "body": "Ҳар корбар танҳо як ҳисоби шахсӣ дошта метавонад. Махфияти маълумоти вуруд ба зиммаи шумост."
        },
        {
          "heading": "3. Синну сол",
          "body": "Хидмат танҳо барои шахсони ба синни қонунӣ расида. Санҷиш талаб шуда метавонад."
        },
        {
          "heading": "4. Амалҳои манъшуда",
          "body": "Қаллобӣ, сӯиистифода аз автоматӣ ва фаъолияти ғайриқонунӣ манъ аст."
        },
        {
          "heading": "5. Тағйири хидмат",
          "body": "Функсияҳо ва каталог бо огоҳӣ тағйир ё муваққатан қатъ шуда метавонанд."
        },
        {
          "heading": "6. Тамос",
          "body": "Барои баҳсҳо Дастгирии зиндаро истифода баред."
        }
      ]
    },
    "privacy": {
      "title": "Сиёсати махфият",
      "summary": "Ҷамъоварӣ, нигоҳдорӣ ва истифодаи маълумоти шахсӣ.",
      "sections": [
        {
          "heading": "1. Кадом маълумот",
          "body": "Ҳисоб, тамос, метамаълумоти пардохт, журналҳои техникӣ ва мукотибаи дастгирӣ коркард шуда метавонанд."
        },
        {
          "heading": "2. Мақсад",
          "body": "Маълумот барои идораи ҳисоб, амният, пардохтҳо, дастгирӣ ва уҳдадориҳои қонунӣ истифода мешавад."
        },
        {
          "heading": "3. Мубодила",
          "body": "Маълумот фурӯхта намешавад; ба провайдерҳои пардохт/бозӣ ва мақомот тибқи қонун дода шуда метавонад."
        },
        {
          "heading": "4. Муҳлати нигоҳдорӣ",
          "body": "Барои хидмат ва қонун зарур нигоҳ дошта, сипас нест ё беном карда мешавад."
        },
        {
          "heading": "5. Ҳуқуқҳои шумо",
          "body": "Тавассути дастгирӣ дархости дастрасӣ, ислоҳ ё несткунӣ фиристода метавонед."
        },
        {
          "heading": "6. Амният",
          "body": "Чораҳои техникӣ ва ташкилӣ татбиқ мешаванд; системаи бехатар 100% нест."
        }
      ]
    },
    "bonuses": {
      "title": "Қоидаҳои бонус",
      "summary": "Бонусҳо, промокодҳо ва шартҳои чархи шонс.",
      "sections": [
        {
          "heading": "1. Умумӣ",
          "body": "Бонусҳо ба шартҳои кампания ва ҳолати ҳисоб вобастаанд."
        },
        {
          "heading": "2. Тавозуни воқеӣ ва бонус",
          "body": "Маблағҳо алоҳида ҳисоб мешаванд. Бозии бонусӣ танҳо дар бозиҳои иҷозатшуда."
        },
        {
          "heading": "3. Вейҷер",
          "body": "Талаботи гардиш дар кампания нишон дода мешавад; иҷро нашудан бонусро бекор карда метавонад."
        },
        {
          "heading": "4. Сӯиистифода",
          "body": "Ҳисобҳои сершумор ё гузаштан аз шартҳо бонусро бекор карда метавонад."
        },
        {
          "heading": "5. Тағйирот",
          "body": "Кампанияҳо қатъ ё тағйир ёфта метавонанд."
        }
      ]
    },
    "payments": {
      "title": "Амонат ва гирифтан",
      "summary": "Усулҳои пардохт, лимитҳо ва санҷиш.",
      "sections": [
        {
          "heading": "1. Амонат",
          "body": "Танҳо усулҳои фаъол қабул мешаванд. Шабака/реквизит/маблағи нодуруст таъхир ё талафот оварда метавонад."
        },
        {
          "heading": "2. Гирифтан",
          "body": "Дархостҳо санҷида мешаванд; KYC талаб шуда метавонад."
        },
        {
          "heading": "3. Асъор",
          "body": "Асъори асосӣ дар платформа нишон дода мешавад."
        },
        {
          "heading": "4. Квитансияҳо",
          "body": "Баъзе усулҳо квитансия ё тасдиқи иловагӣ мехоҳанд. Ҳуҷҷати қалбакӣ манъ аст."
        },
        {
          "heading": "5. Бозгашт",
          "body": "Амалиётҳои хато тавассути дастгирӣ ва шарикон баррасӣ мешаванд."
        }
      ]
    },
    "responsible": {
      "title": "Бозии масъулиятнок",
      "summary": "Худмаҳдудкунӣ ва пешгирии рафтори зарарнок.",
      "sections": [
        {
          "heading": "1. Принсип",
          "body": "Боzī барои фароғат аст. Бурд кафолат дода намешавад."
        },
        {
          "heading": "2. Абзорҳо",
          "body": "Сардкунӣ, худмаҳдудкунӣ ва пӯшидани ҳисоб дастрас буда метавонад."
        },
        {
          "heading": "3. Кӯмак",
          "body": "Агар хатар ҳис кунед, кӯмаки касбӣ ҷӯед."
        },
        {
          "heading": "4. Ноболиғон",
          "body": "Иштирок манъ аст; чунин ҳисобҳо пӯшида мешаванд."
        }
      ]
    },
    "kyc": {
      "title": "Тасдиқи ҳисоб (KYC)",
      "summary": "Санҷиши шахсият ва тамос.",
      "sections": [
        {
          "heading": "1. Кай",
          "body": "Ҳангоми гирифтан, маблағи калон, хатар ё қонун KYC дархост шуда метавонад."
        },
        {
          "heading": "2. Ҳуҷҷатҳо",
          "body": "Шиноснома, суроға ва исботи пардохт талаб шуда метавонад."
        },
        {
          "heading": "3. Коркард",
          "body": "Маълумот танҳо барои санҷиш ва тибқи сиёсати махфият нигоҳ дошта мешавад."
        },
        {
          "heading": "4. Натиҷа",
          "body": "То анҷоми санҷиш амалиётҳо маҳдуд шуда метавонанд."
        }
      ]
    },
    "aml": {
      "title": "AML ва зидди қаллобӣ",
      "summary": "Пешгирии амалиётҳои шубҳанок.",
      "sections": [
        {
          "heading": "1. Мақсад",
          "body": "Платформа кӯшиш мекунад шустани пул ва қаллобиро пешгирӣ кунад."
        },
        {
          "heading": "2. Мониторинг",
          "body": "Амалиётҳо ва рафтор автоматӣ ва/ё дастӣ санҷида мешаванд."
        },
        {
          "heading": "3. Чораҳо",
          "body": "Ҳангоми шубҳа амонат/гирифтан қатъ ва ҳисоб ях баста мешавад."
        },
        {
          "heading": "4. Ҳамкорӣ",
          "body": "Корбарон бояд ба дархостҳои дастгирӣ сари вақт ҷавоб диҳанд."
        }
      ]
    },
    "fairplay": {
      "title": "Бозии одилона ва синну сол",
      "summary": "Адолати бозӣ, қоидаҳои провайдер ва маҳдудияти синну сол.",
      "sections": [
        {
          "heading": "1. Провайдерҳо",
          "body": "Бозиҳоро провайдерҳои сеюм пешниҳод карда метавонанд; қоидаҳои онҳо амал мекунанд."
        },
        {
          "heading": "2. Натиҷаҳо",
          "body": "Натиҷаро системаи провайдер муайян мекунад."
        },
        {
          "heading": "3. Синну сол",
          "body": "Бозии пули воқеӣ танҳо барои шахсони ба синни қонунӣ расида."
        },
        {
          "heading": "4. Забон",
          "body": "Интерфейси провайдер танҳо дар забонҳои дастгиришаванда нишон дода мешавад."
        }
      ]
    },
    "self_exclusion": {
      "title": "Сиёсати худмаҳдудкунӣ",
      "summary": "Сардкунӣ, худмаҳдудкунӣ ва маҳдуд кардани муваққатӣ ё доимии ҳисоб.",
      "sections": [
        {
          "heading": "1. Мақсад",
          "body": "Ин сиёсат абзорҳои қатъ ё маҳдуд кардани фаъолияти бозиро пешниҳод мекунад."
        },
        {
          "heading": "2. Абзорҳо",
          "body": "Сардкунӣ, худмаҳдудкунӣ ва пӯшидани ҳисоб дар профил/амният ё тавассути Дастгирии зинда дастрас буда метавонад."
        },
        {
          "heading": "3. Таъсир",
          "body": "Ҳангоми худмаҳдудкунӣ амонат, бозӣ ё амалиётҳои дигар маҳдуд шуда метавонанд. Пеш аз анҷоми муҳлат одатан бардошта намешавад."
        },
        {
          "heading": "4. Раванди дархост",
          "body": "Дархостҳои дастгирӣ баррасӣ мешаванд. Тасдиқи шахсият талаб шуда метавонад."
        },
        {
          "heading": "5. Масъулият",
          "body": "Абзорҳо хатарро кам мекунанд, аммо кӯмаки касбиро иваз намекунанд."
        },
        {
          "heading": "6. Эзоҳи ҳуқуқӣ",
          "body": "Маълумоти ширкат пас аз тасдиқи соҳибкор илова мешавад. Ин матни лоиҳа аст."
        }
      ]
    },
    "disputes": {
      "title": "Сиёсати ҳалли баҳсҳо",
      "summary": "Тартиби баррасии баҳсҳои пардохт, бонус, натиҷаи бозӣ ва ҳисоб.",
      "sections": [
        {
          "heading": "1. Доира",
          "body": "Баҳсҳо оид ба амонат/гирифтан, бонус, ҳолати ҳисоб ва сессияҳои бозӣ."
        },
        {
          "heading": "2. Муроҷиати аввал",
          "body": "Аввал тавассути Дастгирии зинда хабар диҳед. Рақами дархост, сана, маблағ ва далелҳоро илова кунед."
        },
        {
          "heading": "3. Санҷиш",
          "body": "Дастгирӣ метавонад журналҳо ва маълумоти пардохт/провайдерро санҷад."
        },
        {
          "heading": "4. Муҳлат",
          "body": "Ҳолатҳои оддӣ тезтар баррасӣ мешаванд; санҷишҳои мураккаб дарозтар мешаванд."
        },
        {
          "heading": "5. Натиҷа",
          "body": "Қарор ба фактҳо асос меёбад. Ҳуҷҷати қалбакӣ метавонад ба маҳдудият оварда расонад."
        },
        {
          "heading": "6. Эскалация",
          "body": "Роҳи иловагии эскалация пас аз тасдиқи соҳибкор илова мешавад. Ин матни лоиҳа аст."
        }
      ]
    }
  }
}
